import type { Property } from "@/store/v2/currentProperty/selectors";
import { isMonitoringRequest } from "@/utils/monitoringUserAgents";

export const initializePendo = ({
  property,
  email,
  name,
  userId,
  topRole,
  isAuthenticated,
}: {
  property: Partial<Property>;
  email: string;
  name: string;
  userId: string | number;
  topRole: string;
  isAuthenticated: boolean;
}) => {
  try {
    if (!isMonitoringRequest() && isAuthenticated) {
      const pendoOptions = {
        account: {
          id: property.id,
          account_name: property.name,
          account_tier: property.tier?.title,
          safe_id: property?.safeId,
          salesforce_id: property?.salesforceId,
        },
        visitor: {
          email,
          full_name: name,
          id: String(userId),
          role: topRole || "NO ROLE",
        },
      };

      if (!window.pendo || !window.pendo.isSendingEvents) {
        return false;
      }

      window.pendo.initialize(pendoOptions);

      if (!property?.name) {
        window.pendo.stopSendingEvents();
        console.log("Pendo is stopped");
        return false;
      }

      window.pendo.updateOptions(pendoOptions);
      console.log("Pendo updated");
      if (!window.pendo.isSendingEvents()) {
        window.pendo.startSendingEvents();
        console.log("Pendo started and sending events");
      }
      return true;
    }
  } catch (err) {
    console.log(err);
  }
  return false;
};
